import { Capacitor } from "@capacitor/core";
import { LocalNotifications } from "@capacitor/local-notifications";
import { StateCreator } from "zustand";
import { BoundStore } from "../bound.store";
import { LocalNotificationsSlice } from "./localNotifications.interface";

export const createLocalNotificationsSlice: StateCreator<
  BoundStore,
  [["zustand/devtools", never]],
  [],
  LocalNotificationsSlice
> = (set) => ({
  scheduleLocalNotifications: false,
  notificationPermissionsGranted: false,
  notificationPermissionDenied: false,
  setScheduleLocalNotifications: (scheduleLocalNotifications: boolean) => {
    set((state) => ({
      ...state,
      scheduleLocalNotifications,
    }));
  },
  syncNotificationPermissions: async () => {
    if (Capacitor.getPlatform() === "web") {
      set((state) => ({
        ...state,
        notificationPermissionsGranted: true,
        notificationPermissionDenied: false,
      }));
      return;
    }
    const permission = await LocalNotifications.checkPermissions();
    set((state) => ({
      ...state,
      notificationPermissionsGranted: permission.display === "granted",
      notificationPermissionDenied: permission.display === "denied",
    }));
  },
  requestNotificationPermissions: async () => {
    if (Capacitor.getPlatform() === "web") {
      set((state) => ({ ...state, notificationPermissionsGranted: true, notificationPermissionDenied: false }));
      return "granted";
    }
    // Only the undecided states can be prompted; "denied" silently no-ops, so the caller routes the
    // user to the device settings instead.
    let permission = await LocalNotifications.checkPermissions();
    if (permission.display === "prompt" || permission.display === "prompt-with-rationale") {
      permission = await LocalNotifications.requestPermissions();
    }
    set((state) => ({
      ...state,
      notificationPermissionsGranted: permission.display === "granted",
      notificationPermissionDenied: permission.display === "denied",
    }));
    return permission.display;
  },
});
